// extracted by mini-css-extract-plugin
export default {"configPage":"ConfigPage_configPage__wxn5k","sidebar":"ConfigPage_sidebar__Xwh5A","active":"ConfigPage_active__q9kr0","content":"ConfigPage_content__Au-Go"};